@import ../../../styles/helpers

.container
    flex-grow: 1
    padding: $context_margin $external_margin
    padding-bottom: 20px
    display: flex
    position: relative
    flex-direction: column-reverse
    overflow-y: auto
    overflow-x: hidden
    gap: 8px
    background-color: none
    border-radius: $border_radius_big
    +m
        gap: 24px !important
    .message:last-of-type
        padding-top: 90px
    .message:first-of-type
        .content
            position: relative
            &:after
                content: ''
                position: absolute
                left: -8px
                bottom: 17px
                width: 0
                height: 0
                border: 9px solid transparent
                border-right-color: $bordercolor
                border-left: 0
        +m
            .content
                position: relative
                &:after
                    content: ''
                    position: absolute
                    left: -5px
                    bottom: 13px
                    width: 0
                    height: 0
                    border: 6px solid transparent
                    border-right-color: $bordercolor
                    border-left: 0
                    +m
            &.mine
                .content
                    position: relative
                    &:after
                        border: 6px solid transparent
                        border-left-color: #1598FF
                        border-right: 0
                        left: auto
                        right: -5px
        &.mine
            .content
                position: relative
                &:after
                    border: 9px solid transparent
                    border-left-color: #1598FF
                    border-right: 0
                    left: auto
                    right: -8px
    
    &::-webkit-scrollbar
        width: 8px
    &::-webkit-scrollbar-track
        background: transparent
        border-radius: 50px
        width: 8px
    &::-webkit-scrollbar-thumb
        background: $dark_icon_background
        border-radius: 50px
        width: 8px
    +m
        margin-bottom: 0px
        border-radius: 0
        gap: 6px
        padding: 6px
        padding-bottom: 25px
        

.message
    display: flex
    align-items: flex-end
    text-align: left

    &.ownLastMessage
        margin-bottom: 30px
    .content
        line-height: 23px
        background: $bordercolor
        color: white
        border-radius: 15px
        padding: 18px 28px
        position: relative
        max-width: 550px
        min-height: 59px
        margin-left: 65px
        +snappy
        font-size: 18px
        font-weight: 500
        span
            overflow-wrap: break-word
        +m
            border-radius: 20px
            min-height: 53px
            padding: 15px
            font-size: 16px
            margin-left: 50px
            max-width: 70%
            

    .avatar
        position: absolute
        width: $icon_size
        height: $icon_size
        margin-right: $external_margin
        display: flex
        justify-content: center
        align-items: center
        img
            border-radius: 100px
        +m
            width: 35px !important
            height: 35px !important
            img
                width: 35px !important
                height: 35px !important

    

    &.showAvatar
        .avatar
            +m
                width: 35px !important
                height: 35px !important
                img
                    width: 35px !important
                    height: 35px !important
        .content
            position: relative
            &:after
                content: ''
                position: absolute
                left: -8px
                bottom: 17px
                width: 0
                height: 0
                border: 9px solid transparent
                border-right-color: $bordercolor
                border-left: 0
        +m
            .content
                position: relative
                &:after
                    content: ''
                    position: absolute
                    left: -5px
                    bottom: 13px
                    width: 0
                    height: 0
                    border: 6px solid transparent
                    border-right-color: $bordercolor
                    border-left: 0
            
    .time
        margin-left: $context_margin
        margin-right: $context_margin
        font-size: 13px
        line-height: 14px
        min-width: 60px
        +snappy
        color: white
        opacity: 0.2
        +m
            font-size: 12px
            position: absolute
            margin-left: 55px
            margin-bottom: -18px



    .sharedContent
        display: flex
        flex-direction: column
        align-items: end
    .sharedImage
        width: 250px
        height: 250px
        border-radius: 15px
        margin-top: 5px
        +m
            margin-top: 0
        +s
            width: 200px
            height: 200px
        +z
            width: 180px
            height: 180px
    .sharedText
        padding: 10px
        padding-right: 0px
        padding-left: 0px
        padding-bottom: 0px
        margin-top: 5px
        display: block
        text-align: center !important
        .time
            position: relative
            margin: 0 auto !important
            margin-top: 5px !important

    &.mine
        align-items: flex-end
        flex-direction: row-reverse
        text-align: right
        .content
            background-color: #1598FF
            color: white
            margin-left: 0
            margin-right: 65px
        +m
            .content
                margin-left: 0
                margin-right: 50px
                max-width: 70%
            
        .avatar
            margin-right: 0px
            margin-left: $external_margin
        &.showAvatar
            .content
                position: relative
                &:after
                    border: 9px solid transparent
                    border-left-color: #1598FF
                    border-right: 0
                    left: auto
                    right: -8px
        +m
            &.showAvatar
                .content
                    position: relative
                    &:after
                        border: 6px solid transparent
                        border-left-color: #1598FF
                        border-right: 0
                        left: auto
                        right: -5px

